import React, { useState, useEffect } from 'react';
import styles from './OfflineBanner.module.css';

const STORAGE_KEY_DISMISSED = 'b2b_offline_banner_dismissed';

/**
 * Banner sottile in alto quando offline. Dismissibile (click, nascosto per sessione).
 */
export const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setDismissed(false);
    };
    const handleOffline = () => setIsOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    if (isOffline) {
      setDismissed(sessionStorage.getItem(STORAGE_KEY_DISMISSED) === '1');
    }
  }, [isOffline]);

  const handleDismiss = (): void => {
    setDismissed(true);
    sessionStorage.setItem(STORAGE_KEY_DISMISSED, '1');
  };

  if (!isOffline || dismissed) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleDismiss}
      onKeyDown={(e) => e.key === 'Enter' && handleDismiss()}
      className={styles.offlineBanner}
      aria-label="Sei offline. Clicca per nascondere."
    >
      Sei offline · Clicca per nascondere
    </div>
  );
};
